module.exports = __webpack_public_path__ + "img/Eibar.c6b03e38.png";